import { render, staticRenderFns } from "./CourseSectionCreateModal.vue?vue&type=template&id=05609afc&"
import script from "./CourseSectionCreateModal.vue?vue&type=script&lang=js&"
export * from "./CourseSectionCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseSectionCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports